import React from 'react'

function LowestNavbar() {
    return (
        <footer className="lowest-navbar">
            <div className="footer-container">
                <h6 className="footer-text">
                    Made by <span className="footer-name">Anubhav Bangari</span>
                </h6>
            </div>
        </footer>
    )
}

export default LowestNavbar